import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ! WARNING: createInstance() method is needed to avoid conflicts when importing the Components in another repos
const i18n = createInstance({
  fallbackLng: 'en',
  supportedLngs: ['en', 'es', 'pt', 'de', 'tr', 'en-GB', 'fr'],
  detection: {
    order: ['navigator']
  },
  nonExplicitSupportedLngs: true,
  debug: false,
  react: {
    useSuspense: false
  }
});
i18n.use(initReactI18next).use({
  type: 'backend',
  read(language, namespace, callback) {
    import(`../locales/${language}/${namespace}.json`).then(resources => {
      callback(null, resources);
    }).catch(error => {
      callback(error, null);
    });
  }
}).use(LanguageDetector).init();
var i18n$1 = i18n;

export { i18n$1 as default };
//# sourceMappingURL=i18n.js.map
